<template>
  <div>
    <v-container>
      <v-col cols="12" sm="12" offset-sm="0">
        <v-card class="maincard">
          <v-container>
            <v-row align="center">
              <v-col cols="12" xs="12" sm="8">
                <v-card-title>Benachrichtigungen</v-card-title>
              </v-col>
              <v-col cols="12" xs="12" sm="4" style="text-align: right">
                <v-btn to="/notifications/edit" color="success">
                  <v-icon style="margin-right: 10px">mdi-plus</v-icon>
                  <span>Neue Benachrichtigung</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>

          <NotificationList />
        </v-card>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import NotificationList from "@/components/notifications/NotificationList.vue";

export default {
  name: "RobotMgmt",
  components: { NotificationList },
  data: () => ({}),
  methods: {}
};
</script>

<style scoped></style>
